import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {PumpsConfiguration, UnloadingMethodsConfiguration} from './types'

export const buildUnloadingMethodConfiguration = ({
  options: {constraints}
}: BuildConfigurationInput): UnloadingMethodsConfiguration & PumpsConfiguration => {
  return {
    unloadingMethods: constraints.unloadingMethods ?? {isEnabled: false},
    pumps: constraints.pumps ?? {isEnabled: false}
  }
}
